// After a deploy the old build's files are gone, and a page opened before it
// asks for a chunk that no longer exists (Sentry STUDIO-BROWSER-2, "Failed to
// fetch dynamically imported module"). Vite announces it with
// vite:preloadError; the page reloads into the new build, as Vite's guide
// says (https://vite.dev/guide/build#load-error-handling). Rails serves the
// HTML with max-age=0 and must-revalidate, so the reload asks for it again
// and gets the new build's file names.
export function installNewBuildReload() {
  window.addEventListener("vite:preloadError", () => window.location.reload())
}
